import { addDays, startOfDay } from "date-fns";
import SearchForm from "../components/SearchForm";
import { useEffect, useState } from "react";
import { Resort, SearchParams, YadoHotel, YadoRoom } from "../types";
import { formatQuery } from "../utils";
import { fetchHotels } from "../api";
import i18n from "../../i18n";
import styles from "../styles/HotelSearch.module.scss"

type HotelsSearchTopProps = {
  featuredAreaCodes: string[];
  otherAreaCodes: string[];
}

const HotelsSearchTop: React.FC<HotelsSearchTopProps> = ({ featuredAreaCodes, otherAreaCodes }) => {
  const today = new Date();
  const fourtyFiveDaysLater = startOfDay(addDays(today, 45));
  const defaultCheckoutDate = addDays(fourtyFiveDaysLater, 1);
  const [hotels, setHotels] = useState<YadoHotel[]>([]);
  const [relatedResorts, setRelatedResorts] = useState<Resort[]>([]);
  const [query, setQuery] = useState<SearchParams>({
    checkinDate: fourtyFiveDaysLater,
    checkoutDate: defaultCheckoutDate,
    people: { adult: 2, children: [] },
    areaCodes: [],
    resortCodes: [],
    skiInOut: null,
    hotSpring: null,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchInitiated, setSearchInitiated] = useState<boolean>(false);

  const handleRedirect = () => {
    setIsLoading(true);
    setSearchInitiated(true);

    const formattedQuery = formatQuery(query);
    const searchParams = new URLSearchParams(formattedQuery).toString();

    const url = `/snow/stay-packages/hotels?${searchParams}`;

    window.location.href = url;
  };


  return (
    <>
      <div className="mx-0 p-3 mb-4 d-flex flex-column" style={{ backgroundColor: '#E6F3FF' }}>
        <div className="row align-items-center justify-content-between px-2">
          <SearchForm
            query={query}
            featuredAreaCodes={featuredAreaCodes}
            otherAreaCodes={otherAreaCodes}
            minDate={startOfDay(today)}
            withResortForm={true}
            handleQueryChange={(newQuery) => setQuery(newQuery)}
          />
          <button
            type='submit'
            onClick={() => handleRedirect()}
            className="btn btn-primary rounded-pill font-weight-bold"
            style={{ flexShrink: 1, flexGrow: 1}}
            disabled={isLoading}
            >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                <span className="sr-only">Loading...</span>
              </>
            ) : (
              i18n.t('components.accommodation.search_form.search')
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default HotelsSearchTop;
